import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "../../../intl.js";
import e from "../../../core/Logger.js";
import { isNone as t, isSome as r } from "../../../core/maybe.js";
import { replace as n } from "../../../core/string.js";
import { formatDate as i, convertDateFormatToIntlOptions as o } from "../../../intl/date.js";
import { formatNumber as a, convertNumberFormatToIntlOptions as u } from "../../../intl/number.js";
import { featureHasFields as l } from "../../../layers/support/fieldUtils.js";
import s from "../../../popup/support/FieldInfoFormat.js";
import { loadArcade as f } from "../../../support/arcadeOnDemand.js";
var c = "esri.widgets.Feature.support.featureUtils",
    d = e.getLogger(c),
    p = /href=(""|'')/gi,
    m = /(\{([^\{\r\n]+)\})/g,
    y = /\'/g,
    g = /^\s*expression\//i,
    h = /(\n)/gi,
    b = /[\u00A0-\u9999<>\&]/gim,
    F = /href\s*=\s*(?:\"([^\"]+)\"|\'([^\']+)\')/gi,
    I = /^(?:mailto:|tel:)/,
    w = "relationships/",
    N = o("short-date-short-time");

function x(e) {
  if (!t(e)) return e.get("sourceLayer") || e.get("layer");
}

function E(_x, _x2) {
  return _E.apply(this, arguments);
}

function _E() {
  _E = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, t) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", "function" == typeof e ? e.call(null, t) : e);

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _E.apply(this, arguments);
}

function v() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  if (e) return !I.test(e.trim().toLowerCase());
}

function j(e) {
  return !!e && g.test(e);
}

function T(e, t) {
  if (!j(t) || !e) return null;
  var r = t.replace(g, "").toLowerCase();
  var n;
  return e.some(function (e) {
    return e.name.toLowerCase() === r && (n = e, !0);
  }), n;
}

function C(e, t) {
  var r = T(t, null == e ? void 0 : e.fieldName);
  return r ? r.title || null : e ? e.label || e.fieldName : null;
}

function q(e, t) {
  var r = t.get(e.toLowerCase());
  return "{".concat(r && r.fieldName || e, "}");
}

function D(e) {
  return e.replace(p, "");
}

function R(e, t) {
  var r = M(t, e);
  return r ? r.name : e;
}

function L(e, t) {
  return e && e.map(function (e) {
    return R(e, t);
  });
}

function M(e, t) {
  return e && "function" == typeof e.getField ? e.getField(t) : null;
}

function U(e) {
  return "".concat(e).trim();
}

function $(_ref) {
  var e = _ref.attributes,
      t = _ref.globalAttributes,
      r = _ref.layer,
      n = _ref.text,
      i = _ref.expressionAttributes,
      o = _ref.fieldInfoMap;
  return n ? A({
    formattedAttributes: t,
    template: P(n, _objectSpread(_objectSpread(_objectSpread({}, t), i), e), r),
    fieldInfoMap: o
  }) : "";
}

function A(_ref2) {
  var e = _ref2.formattedAttributes,
      t = _ref2.template,
      r = _ref2.fieldInfoMap;
  return U(D(n(n(t, function (e) {
    return q(e, r);
  }), e)));
}

function O(e, t) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  var n = t[e];

  if ("string" == typeof n) {
    var _i = "%27",
        _o = (r ? encodeURIComponent(n) : n).replace(y, _i);

    t[e] = _o;
  }
}

function S(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

  var r = _objectSpread({}, e);

  return Object.keys(r).forEach(function (e) {
    return O(e, r, t);
  }), r;
}

function G(e, t, r) {
  var i = (t = U(t)) && "{" !== t[0];
  return n(e, S(r, i));
}

function k(e, t) {
  return e.replace(m, function (e, r, n) {
    var i = M(t, n);
    return i ? "{".concat(i.name, "}") : r;
  });
}

function P(e, t, r) {
  var n = k(e, r);
  return n ? n.replace(F, function (e, r, n) {
    return G(e, r || n, t);
  }) : n;
}

function _(e, t) {
  if ("string" == typeof e && t && null == t.dateFormat && (null != t.places || null != t.digitSeparator)) {
    var _t = Number(e);

    if (!isNaN(_t)) return _t;
  }

  return e;
}

function z(e) {
  return "feature" === (null == e ? void 0 : e.type);
}

function H(e) {
  return "map-image" === (null == e ? void 0 : e.type);
}

function Q(e) {
  return !(null == e || !e.layer);
}

function Z(e, t) {
  var r = t.fieldInfos,
      n = t.fieldName,
      i = B(r, n),
      o = null == i ? void 0 : i.clone(),
      l = t.preventPlacesFormatting,
      f = t.layer,
      c = M(f, n);

  if (o && "date" === (null == c ? void 0 : c.type)) {
    var _e = o.format || new s();

    _e.dateFormat = _e.dateFormat || "short-date-short-time", _e.dateTimeFormatOptions = z(f) && f.datesInUnknownTimezone || Q(f) && H(f.layer) && f.layer.datesInUnknownTimezone ? {
      timeZone: "UTC"
    } : null, o.format = _e;
  }

  var d = o && o.format;
  return "string" == typeof (e = _(e, d)) || null == e || null == d ? ee(e) : l ? a(e, _objectSpread(_objectSpread({}, u(d)), {}, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 20
  })) : d.format(e);
}

function B(e, t) {
  if (!e || !e.length || !t) return;
  var r = t.toLowerCase();
  var n;
  return e.some(function (e) {
    return !(!e.fieldName || e.fieldName.toLowerCase() !== r) && (n = e, !0);
  }), n;
}

function J(_ref3) {
  var e = _ref3.fieldName,
      t = _ref3.graphic,
      r = _ref3.layer;
  if (ae(e)) return null;
  if (!r || "function" != typeof r.getFeatureType) return null;
  var n = r.typeIdField;
  if (!n || e !== n) return null;
  var i = r.getFeatureType(t);
  return i ? i.name : null;
}

function K(_ref4) {
  var e = _ref4.fieldName,
      t = _ref4.value,
      r = _ref4.graphic,
      n = _ref4.layer;
  if (ae(e)) return null;
  if (!n || "function" != typeof n.getFieldDomain) return null;
  var i = n.getFieldDomain(e, {
    feature: r
  });
  return i && "coded-value" === i.type ? i.getName(t) : null;
}

function V(e, t) {
  var r = e.creatorField,
      n = e.creationDateField,
      o = e.editorField,
      a = e.editDateField;
  if (!t) return;
  var u = t[a];

  if ("number" == typeof u) {
    var _e2 = t[o];
    return {
      type: "edit",
      date: i(u, N),
      user: _e2
    };
  }

  var l = t[n];

  if ("number" == typeof l) {
    var _e3 = t[r];
    return {
      type: "create",
      date: i(l, N),
      user: _e3
    };
  }

  return null;
}

function W(e, t) {
  var r = new Map();
  return e && e.forEach(function (e) {
    var n = R(e.fieldName, t);
    e.fieldName = n, r.set(n.toLowerCase(), e);
  }), r;
}

function X(e) {
  var t = [];
  if (!e) return t;
  var r = e.fieldInfos,
      n = e.content;
  return r && t.push.apply(t, _toConsumableArray(r)), n && Array.isArray(n) ? (n.forEach(function (e) {
    if ("fields" === e.type) {
      var _r = e && e.fieldInfos;

      _r && t.push.apply(t, _toConsumableArray(_r));
    }
  }), t) : t;
}

function Y(e) {
  return e.replace(b, function (e) {
    return "&#".concat(e.charCodeAt(0), ";");
  });
}

function ee(e) {
  return "string" == typeof e ? e.replace(h, '<br class="esri-text-new-line" />') : e;
}

function te(e) {
  var t = e.value,
      r = e.fieldName,
      n = e.fieldInfos,
      o = e.fieldInfoMap,
      a = e.layer,
      u = e.graphic;
  if (null == t) return "";
  var l = K({
    fieldName: r,
    value: t,
    graphic: u,
    layer: a
  });
  if (l) return l;
  var s = J({
    fieldName: r,
    graphic: u,
    layer: a
  });
  if (s) return s;
  if (o.get(r.toLowerCase())) return Z(t, {
    fieldInfos: n,
    fieldName: r,
    layer: a
  });
  var f = a && a.fieldsIndex;
  return f && f.isDateField(r) ? i(t, N) : ee(t);
}

function re(_ref5) {
  var e = _ref5.fieldInfos,
      t = _ref5.attributes,
      r = _ref5.layer,
      n = _ref5.graphic,
      i = _ref5.fieldInfoMap,
      o = _ref5.relatedInfos;
  var a = {};
  return null == o || o.forEach(function (e) {
    return se(a, e);
  }), Object.keys(t).forEach(function (o) {
    var u = t[o];
    a[o] = te({
      fieldName: o,
      fieldInfos: e,
      fieldInfoMap: i,
      layer: r,
      value: u,
      graphic: n
    });
  }), a;
}

function ne(_x3, _x4) {
  return _ne.apply(this, arguments);
}

function _ne() {
  _ne = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, t) {
    var r, n, i, o, a, u, l, s, f, _e4, _t2, _e5, _t3, c;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            i = e.layer, o = e.graphic, a = e.outFields, u = e.objectIds, l = e.returnGeometry, s = e.spatialReference, f = u[0];

            if (!("number" != typeof f && "string" != typeof f)) {
              _context2.next = 4;
              break;
            }

            _e4 = "Could not query required fields for the specified feature. The feature's ID is invalid.", _t2 = {
              layer: i,
              graphic: o,
              objectId: f,
              requiredFields: a
            };
            return _context2.abrupt("return", (d.warn(_e4, _t2), null));

          case 4:
            if (!(null == (r = i.capabilities) || null == (n = r.operations) || !n.supportsQuery)) {
              _context2.next = 7;
              break;
            }

            _e5 = "The specified layer cannot be queried. The following fields will not be available.", _t3 = {
              layer: i,
              graphic: o,
              requiredFields: a,
              returnGeometry: l
            };
            return _context2.abrupt("return", (d.warn(_e5, _t3), null));

          case 7:
            c = i.createQuery();
            c.objectIds = u, c.outFields = null != a && a.length ? a : [i.objectIdField], c.returnGeometry = !!l, c.returnZ = !!l, c.returnM = !!l, c.outSpatialReference = s;
            _context2.next = 11;
            return i.queryFeatures(c, t);

          case 11:
            return _context2.abrupt("return", _context2.sent.features[0]);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _ne.apply(this, arguments);
}

function ie(_x5) {
  return _ie.apply(this, arguments);
}

function _ie() {
  _ie = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
    var t, r, n;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(null == (t = e.expressionInfos) || !t.length)) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return", !1);

          case 2:
            _context3.next = 4;
            return f();

          case 4:
            r = _context3.sent;
            n = r.arcadeUtils.hasGeometryFunctions;
            return _context3.abrupt("return", n(e));

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _ie.apply(this, arguments);
}

function oe(_x6, _x7) {
  return _oe.apply(this, arguments);
}

function _oe() {
  _oe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref6, i) {
    var e, t, r, n, o, a, u, s, f, c, d;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            e = _ref6.graphic, t = _ref6.popupTemplate, r = _ref6.layer, n = _ref6.spatialReference;

            if (!(!r || !t)) {
              _context4.next = 3;
              break;
            }

            return _context4.abrupt("return");

          case 3:
            _context4.t0 = "function" == typeof r.load;

            if (!_context4.t0) {
              _context4.next = 7;
              break;
            }

            _context4.next = 7;
            return r.load(i);

          case 7:
            if (e.attributes) {
              _context4.next = 9;
              break;
            }

            return _context4.abrupt("return");

          case 9:
            o = e.attributes[r.objectIdField];

            if (!(null == o)) {
              _context4.next = 12;
              break;
            }

            return _context4.abrupt("return");

          case 12:
            a = [o];
            _context4.next = 15;
            return t.getRequiredFields(r.fieldsIndex);

          case 15:
            u = _context4.sent;
            s = l(u, e);
            f = s ? [] : u;
            _context4.t1 = t.returnGeometry;

            if (_context4.t1) {
              _context4.next = 23;
              break;
            }

            _context4.next = 22;
            return ie(t);

          case 22:
            _context4.t1 = _context4.sent;

          case 23:
            c = _context4.t1;

            if (!(s && !c)) {
              _context4.next = 26;
              break;
            }

            return _context4.abrupt("return");

          case 26:
            _context4.next = 28;
            return ne({
              layer: r,
              graphic: e,
              outFields: f,
              objectIds: a,
              returnGeometry: c,
              spatialReference: n
            }, i);

          case 28:
            d = _context4.sent;
            d && (d.geometry && (e.geometry = d.geometry), d.attributes && (e.attributes = _objectSpread(_objectSpread({}, e.attributes), d.attributes)));

          case 30:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _oe.apply(this, arguments);
}

function ae() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return !!e && -1 !== e.indexOf(w);
}

function ue(e) {
  return e ? "".concat(w).concat(e.layerId, "/").concat(e.fieldName) : "";
}

function le(_ref7) {
  var e = _ref7.attributes,
      t = _ref7.graphic,
      r = _ref7.relatedInfo;
  e && t && r && Object.keys(t.attributes).forEach(function (n) {
    var i = ue({
      layerId: r.relation.id.toString(),
      fieldName: n
    });
    e[i] = t.attributes[n];
  });
}

function se(e, t) {
  e && t && (t.relatedFeatures && t.relatedFeatures && t.relatedFeatures.forEach(function (r) {
    return le({
      attributes: e,
      graphic: r,
      relatedInfo: t
    });
  }), t.relatedStatsFeatures && t.relatedStatsFeatures && t.relatedStatsFeatures.forEach(function (r) {
    return le({
      attributes: e,
      graphic: r,
      relatedInfo: t
    });
  }));
}

var fe = function fe(e) {
  if (!e) return !1;
  var t = e.toUpperCase();
  return t.indexOf("CURRENT_TIMESTAMP") > -1 || t.indexOf("CURRENT_DATE") > -1 || t.indexOf("CURRENT_TIME") > -1;
},
    ce = function ce(_ref8) {
  var e = _ref8.layer,
      t = _ref8.method,
      n = _ref8.query,
      i = _ref8.definitionExpression;
  var o, a;
  if (null == (o = e.capabilities) || null == (a = o.query) || !a.supportsCacheHint || "attachments" === t) return;
  var u = r(n.where) && n.where,
      l = r(n.geometry) && n.geometry;
  fe(i) || fe(u) || "extent" === (null == l ? void 0 : l.type) || "tile" === n.resultType || (n.cacheHint = !0);
},
    de = function de(_ref9) {
  var e = _ref9.query,
      t = _ref9.layer,
      r = _ref9.method;
  ce({
    layer: t,
    method: r,
    query: e,
    definitionExpression: "".concat(t.definitionExpression, " ").concat(t.serviceDefinitionExpression)
  });
},
    pe = function pe(_ref10) {
  var e = _ref10.queryPayload,
      t = _ref10.layer,
      r = _ref10.method;
  ce({
    layer: t,
    method: r,
    query: e,
    definitionExpression: "".concat(t.definitionExpression, " ").concat(t.serviceDefinitionExpression)
  });
};

export { ee as applyTextFormattingHTML, W as createfieldInfoMap, k as fixTokens, re as formatAttributes, V as formatEditInfo, Z as formatValueToFieldInfo, X as getAllFieldInfos, B as getFieldInfo, C as getFieldInfoLabel, R as getFixedFieldName, L as getFixedFieldNames, x as getSourceLayer, E as graphicCallback, Y as htmlEntities, j as isExpressionField, ae as isRelatedField, de as preLayerQueryCallback, pe as preRequestCallback, oe as queryUpdatedFeature, v as shouldOpenInNewTab, A as substituteAttributes, $ as substituteFieldsInLinksAndAttributes };